// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-control-semantic .search-input{
    display:block !important;    
    padding-left:50px;
}
.search-items-semantic-response-text{
    padding:30px;
}

.search-items-semantic-wrapper{
    white-space: pre-line;
    display: block;    
    border: 1px solid #e7ebee !important;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    min-height: 500px;
    margin-left: 50px;
}

.semantic-search-label{
    font-weight: bold;
    margin-top: 20px;
    padding-left: 50px;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/controls/sem-search/sem-search.component.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,iBAAiB;AACrB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,oCAAoC;IACpC,2BAA2B;IAC3B,8BAA8B;IAC9B,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB","sourcesContent":[".search-control-semantic .search-input{\r\n    display:block !important;    \r\n    padding-left:50px;\r\n}\r\n.search-items-semantic-response-text{\r\n    padding:30px;\r\n}\r\n\r\n.search-items-semantic-wrapper{\r\n    white-space: pre-line;\r\n    display: block;    \r\n    border: 1px solid #e7ebee !important;\r\n    border-top-left-radius: 5px;\r\n    border-bottom-left-radius: 5px;\r\n    min-height: 500px;\r\n    margin-left: 50px;\r\n}\r\n\r\n.semantic-search-label{\r\n    font-weight: bold;\r\n    margin-top: 20px;\r\n    padding-left: 50px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
